import type { QueryHookOptions } from "@apollo/client";
import { useQuery, gql } from "@apollo/client";

import { STORE_SETUP_FRAGMENT } from "@shared/data/fragments/StoreSetupFragment/StoreSetupFragment.fragment";
import type { Store } from "@shared/types/graphqlGenerated";

const StoreSetup_Shared_Query = gql`
  query StoreSetup_Shared_Query($storePlatform: String) {
    currentStore {
      id
      currentSetupPage
      marginType
      storeSetup(storePlatform: $storePlatform) {
        ...StoreSetupFragment
      }
    }
  }
  ${STORE_SETUP_FRAGMENT}
`;

type StoreSplinter = Pick<Store, "id" | "currentSetupPage" | "marginType" | "storeSetup">;
interface StoreSetupData {
  currentStore: StoreSplinter;
}

interface Variables {
  storePlatform?: string;
}

const useStoreSetupQuery = (options?: QueryHookOptions<StoreSetupData, Variables>) => {
  return useQuery<StoreSetupData, Variables>(StoreSetup_Shared_Query, options);
};

export type { StoreSetupData };

/* eslint-disable @fullscript/gql-no-manual-hook-declaration */
export { useStoreSetupQuery, StoreSetup_Shared_Query };
